import { render, staticRenderFns } from "./ValueWithComparisonSubtext.vue?vue&type=template&id=b3075e54&scoped=true&"
import script from "./ValueWithComparisonSubtext.vue?vue&type=script&lang=js&"
export * from "./ValueWithComparisonSubtext.vue?vue&type=script&lang=js&"
import style0 from "./ValueWithComparisonSubtext.vue?vue&type=style&index=0&id=b3075e54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3075e54",
  null
  
)

export default component.exports